import logo from "../assets/logo.png";
import logo2 from "../assets/logo2.png";
import Button from "../common/Button";
import Social from "../components/Social";
import { IoChevronForward } from "react-icons/io5";

const Home = ({ streak, handlePlay }) => {
  return (
    <div className="py-16 bg-primary2 min-h-screen">
      <div className="mx-auto max-w-[570px] px-6 w-full">
        <img
          src={logo}
          alt="Sporting Cryptic"
          className="size-24 mx-auto mb-5 bg-white rounded-full"
        />

        <div className="bg-primary p-4 w-fit mx-auto rounded-lg text-center mb-5">
          <p className="font-bold text-lg !font-railway">SPORTING CRYPTIC</p>
          <p className="!font-railway font-medium">A daily cryptic sports clue for you to solve</p>
        </div>

        <Button
          onClick={handlePlay}
          className="flex gap-1 items-center mx-auto"
        >
          <img
            src={logo2}
            className="bg-white rounded-full size-5"
            alt=""
          />
          Play
          <IoChevronForward
            fill="var(--main)"
            size={18}
          />
        </Button>

        <div className="my-6 text-center text-lg">
          <p>
            You are on a streak of <b>{streak} days</b>
          </p>
          {/* <p>
            You score: <b>0</b>
          </p> */}
        </div>

        <div className="py-8">
          <Social />
          <p className="mt-3 max-md:text-sm text-center">
            Don’t worry we are friendly and here to help you solve clues
          </p>
        </div>

        <div className="border-t border-[#6b7280] my-4 pt-4 px-1 md:px-3 flex justify-between w-full gap-4">
          <span className="text-[10px] sm:text-xs">© 2024 Sporting Cryptic</span>
          <a
            href="#"
            className="text-[10px] sm:text-xs text-main underline"
          >
            Privacy Policy
          </a>
          <a
            href="#"
            className="text-[10px] sm:text-xs text-main underline"
          >
            Contact Us
          </a>
        </div>
      </div>
    </div>
  );
};

export default Home;
